import type { NextPage } from 'next';
import Head from 'next/head';

import GiftsPage from '@containers/GiftsPage';
import { snackbarInfo } from 'store/utils';
import { GET_SERVICEABLE_COUNTRIES_ONLY } from 'src/http/countryAlone';
import { createApolloClient } from '../../graphql';
import { ICountryList } from '@utils/types';

interface IGifts {
  getServiceableCountries: ICountryList[];
}

const Gifts = ({ getServiceableCountries }: IGifts) => {
  return (
    <>
      <Head>
        <title>Gifts | The Cumin Club</title>
      </Head>
      <GiftsPage getServiceableCountries={getServiceableCountries} />
    </>
  );
};

export default Gifts;

export const getStaticProps = async () => {
  const apolloClient = createApolloClient();

  const fetchServiceableCountries = async () => {
    try {
      const res = await apolloClient.query({
        query: GET_SERVICEABLE_COUNTRIES_ONLY,
      });
      if (res?.data) {
        const { data } = res || {};
        const { getServiceableCountries } = data || {};
        return getServiceableCountries;
      }
    } catch (error: any) {
      snackbarInfo({
        message: error?.message,
        type: 'error',
      });
      console.log(error);
      return { error };
    }
  };

  const getServiceableCountries = await fetchServiceableCountries();

  // Pass data to the page via props
  return {
    props: {
      getServiceableCountries,
    },
  };
};
